export const TestIds = {
  NewAmendmentButton: 'new-amendment-button',
  changeType: 'change-type',
};
